import { Navigate, Outlet } from 'react-router-dom';


function AuthLayout() {
    const token = sessionStorage.getItem("apayroucarayxczijiuhxvkdsp");


    return token ? <Navigate to='/dashboard' /> : <Outlet />;

}

export default AuthLayout;
